const trimTrailingSlash = (value) => value?.replace(/\/+$/, "") || "";

export const api_url =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080/api"
    : "/api";

export const BACKEND_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : window.location.origin;

export const DEFAULT_LOGO_SRC = `${BACKEND_URL}/images/logo.png`;
export const MALE_PROFILE_PICTURE = `${BACKEND_URL}/images/male.png`;
export const FEMALE_PROFILE_PICTURE = `${BACKEND_URL}/images/female.png`;
